/*
 * fs-bfcm-bar.js — the Black Month bar and its early-access email gate
 * (sections/fs-bfcm-bar.liquid; the why is in that file's header).
 * Ported from OTOTO's ds-promo-bar inline script, 2026-10-27.
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-fs-bfbar]');
  var pop = document.querySelector('[data-fs-bfgate]');
  var bfcm = window.FsBfcm;
  if (!bar || !bfcm) return;

  var offer = bfcm.offer();
  if (!offer) return; /* soon / over: the bar stays hidden */

  var copy = {};
  try { copy = JSON.parse(document.querySelector('[data-fs-bfbar-copy]').textContent)[offer.phase] || {}; } catch (e) { copy = {}; }
  function fill(s) { return (s || '').replace(/\[pct\]/g, offer.pct); }
  /* As fill(), but "[pct]% off" comes out in red: the saving is the message. */
  function paint(el, s) {
    if (!el) return;
    el.textContent = '';
    (s || '').split(/(\[pct\]%(?: off)?)/).forEach(function (part, i) {
      if (!part) return;
      if (i % 2) {
        var b = document.createElement('strong');
        b.className = 'fs-bfbar__hot';
        b.textContent = fill(part);
        el.appendChild(b);
      } else {
        el.appendChild(document.createTextNode(fill(part)));
      }
    });
  }
  bar.querySelector('[data-fs-bfbar-title]').textContent = fill(copy.title);
  paint(bar.querySelector('[data-fs-bfbar-text]'), copy.text);
  paint(bar.querySelector('[data-fs-bfbar-short]'), copy.short);
  bar.querySelector('[data-fs-bfbar-cta]').textContent = fill(copy.cta);
  bar.hidden = false;

  /* During BFCM the page is open to everyone: the bar is a plain link. So is it
     without <dialog> support. */
  var gated = offer.phase === 'pre' && pop && typeof pop.showModal === 'function';

  if (pop) {
    pop.querySelectorAll('[data-fs-bfgate-pct]').forEach(function (el) { el.textContent = offer.pct; });
    pop.querySelectorAll('[data-fs-bfgate-pcttext]').forEach(function (el) { el.textContent = fill(el.textContent); });
  }

  /* Anything else that wants the gate (the Black Month popup) asks with
     [data-fs-bf-gate-open]; outside early access it just follows its link. */
  window.FsBfcm.openGate = gated ? function () { open(); return true; } : function () { return false; };
  if (!gated) return;

  var KEY = 'fs-bf-unlocked';
  var form = document.getElementById('fs-bf-form');
  var email = pop.querySelector('[data-fs-bfgate-email]');
  var field = pop.querySelector('[data-fs-bfgate-field]');
  var submit = pop.querySelector('[data-fs-bfgate-submit]');
  var submitLabel = submit.textContent;
  var errorEl = pop.querySelector('[data-fs-bfgate-error]');
  var ask = pop.querySelector('[data-fs-bfgate-ask]');
  var done = pop.querySelector('[data-fs-bfgate-done]');
  var titles = pop.querySelectorAll('.fs-bfgate__title');
  var LIST = ask.getAttribute('data-kl-list'), SITE = ask.getAttribute('data-kl-key');
  form.noValidate = true; /* our own message, not the browser's bubble */

  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function showDone() {
    ask.hidden = true;
    done.hidden = false;
    if (titles[1]) { titles[0].removeAttribute('id'); titles[1].id = 'fs-bfgate-title'; }
    set(KEY, '1');
    var go = done.querySelector('.fs-bfgate__go');
    if (go && pop.open) go.focus();
  }
  function open(keepError) {
    if (!keepError) { errorEl.textContent = ''; field.classList.remove('is-invalid'); }
    /* Only one dialog at a time: the Black Month popup steps aside. */
    document.querySelectorAll('dialog[open]').forEach(function (d) { if (d !== pop) d.close(); });
    if (!pop.open) pop.showModal();
    if (get(KEY)) showDone();
    else email.focus();
  }
  function busy(on) {
    submit.disabled = on;
    submit.textContent = on ? 'One moment…' : submitLabel;
  }
  function fail(msg) {
    busy(false);
    errorEl.textContent = msg;
    field.classList.add('is-invalid');
    email.focus();
  }
  /* The Shopify path: a REAL submit of this form, so hCaptcha adds its token
     (form.submit() fires no submit event). Shopify's captcha bootstrap swallows
     that submit, silently, until hCaptcha is BOUND to the form, and it binds on
     a focus or change inside the form. Typing the address did that, so it is
     normally bound already; a fast click or an autofill is waited for, up to
     8 s. If it never binds (a blocker), the shopper gets the link anyway:
     a lost sign-up is better than a button that does nothing. */
  var handingOff = false;
  function captchaBound() {
    if (!(window.Shopify && window.Shopify.captcha)) return true; /* no captcha on this shop */
    return !!(form.dataset.hcaptchaBound || form.dataset.recaptchaBound);
  }
  /* A visible puzzle would sit under the modal, unclickable: step aside for it. */
  function watchForPuzzle() {
    if (!window.MutationObserver) return;
    var mo = new MutationObserver(function () {
      var frames = document.querySelectorAll('iframe[src*="hcaptcha"]');
      for (var i = 0; i < frames.length; i++) {
        if (/challenge/i.test(frames[i].src) && frames[i].offsetHeight > 100) { mo.disconnect(); pop.close(); return; }
      }
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    setTimeout(function () { mo.disconnect(); }, 60000);
  }
  function viaShopify() {
    busy(true);
    var waited = 0;
    (function go() {
      if (captchaBound()) {
        handingOff = true;
        watchForPuzzle();
        if (form.requestSubmit) form.requestSubmit(submit); else submit.click();
        /* Still here 20 s later (a puzzle abandoned, a dead network): let them retry. */
        setTimeout(function () { handingOff = false; busy(false); }, 20000);
        return;
      }
      if ((waited += 200) > 8000) { busy(false); showDone(); return; }
      setTimeout(go, 200);
    })();
  }

  bar.addEventListener('click', function (e) { e.preventDefault(); open(); });
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-fs-bf-gate-open]');
    if (!t) return;
    e.preventDefault();
    open();
  });
  pop.querySelector('[data-fs-bfgate-close]').addEventListener('click', function () { pop.close(); });
  /* A click on the backdrop lands on the dialog element itself. */
  pop.addEventListener('click', function (e) { if (e.target === pop) pop.close(); });
  email.addEventListener('input', function () { field.classList.remove('is-invalid'); errorEl.textContent = ''; });

  form.addEventListener('submit', function (e) {
    /* Our own hand-off (and hCaptcha's resubmit after its token): let it post. */
    if (handingOff) return;
    e.preventDefault();
    var addr = email.value.trim();
    if (!addr || !email.checkValidity()) { fail('Please enter a valid email address.'); return; }
    if (!LIST) { viaShopify(); return; }
    busy(true);
    errorEl.textContent = '';
    /* No answer within 8 s → use the Shopify path, so a stalled request never
       leaves the shopper on "One moment…". */
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctrl) ctrl.abort(); else viaShopify(); }, 8000);
    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(SITE), {
      method: 'POST',
      signal: ctrl ? ctrl.signal : undefined,
      headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2025-01-15' },
      body: JSON.stringify({ data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Black Month early access',
          profile: { data: { type: 'profile', attributes: {
            email: addr,
            subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        },
        relationships: { list: { data: { type: 'list', id: LIST } } }
      } })
    })
      .then(function (res) {
        clearTimeout(timer);
        if (res.ok) { busy(false); showDone(); return; }
        /* A bad address is the shopper's to fix; anything else is ours, so the
           email still goes through Shopify rather than being lost. */
        return res.json().then(function (j) {
          var er = j && j.errors && j.errors[0];
          if (res.status < 500 && er && /email/i.test((er.source && er.source.pointer) || '')) fail(er.detail || 'Please check your email address.');
          else viaShopify();
        }, function () { viaShopify(); });
      })
      .catch(function () { clearTimeout(timer); viaShopify(); });
  });

  pop.querySelector('[data-fs-bfgate-copy]').addEventListener('click', function (e) {
    var b = e.currentTarget, url = b.getAttribute('data-url');
    var ok = function () { b.textContent = 'Copied'; setTimeout(function () { b.textContent = 'Copy link'; }, 1800); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(ok, function () {});
  });

  /* Back from the Shopify path: the redirect keeps the action's #fs-bf-form. */
  if (location.hash === '#fs-bf-form') {
    var posted = form.querySelector('[data-fs-bfgate-posted]').textContent.trim() === '1';
    var msg = form.querySelector('[data-fs-bfgate-shopify-error]').textContent.trim();
    if (posted || /taken|already|exist/i.test(msg)) { set(KEY, '1'); open(); }
    else if (msg) { errorEl.textContent = msg; field.classList.add('is-invalid'); open(true); }
    /* Drop `customer_posted` and the hash, so a reload does not reopen it. */
    try {
      var u = new URL(location.href);
      u.searchParams.delete('customer_posted');
      history.replaceState(null, '', u.pathname + (u.search || ''));
    } catch (err) {}
  }
})();
